import React from "react";
import { useTranslation } from "react-i18next";
import CoomingSoon from "../../CoomingSoon";

function Bills() {
    const { t } = useTranslation();
    return <CoomingSoon />
}

export default Bills;
